// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\n@media screen and (min-width: 769px) {\na[href*=\"tel:\"][data-v-403b6b08] {\n    cursor: default;\n    pointer-events: none;\n    color: hsl(0deg, 0%, 29%);\n}\n}\n.navbar-item-active[data-v-403b6b08] {\n  color: hsl(229deg, 53%, 53%);\n  border-bottom: 2px solid hsl(229deg, 53%, 53%);\n}\n.navbar-item-active[href=\"/\"][data-v-403b6b08] {\n  color: #4a4a4a;\n  border-bottom: none;\n}", ""]);
// Exports
module.exports = exports;
